module.exports = __webpack_public_path__ + "img/tree-right.4c90dd29.svg";